import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import "./Testimonials.css";

const testimonials = [
    {
        text: "Solved more problems than any other service",
        name: "Daniel E.",
    },
    {
        text: "Every email marketer should use Emailable!",
        name: "Sarah S.",
    },
    {
        text: "Best email verifier tool",
        name: "Mandar P.",
    },
    {
        text: "Super effective, magic behind the scenes",
        name: "Guillaume W.",
    },
];

export default function Testimonials() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <section className="reviews-section">
            {testimonials.map((t, i) => (
                <div key={i} className="review-card" data-aos="fade-up" data-aos-delay={i * 100}>
                    <div className="stars">★★★★★</div>
                    <p className="review-text">{t.text}</p>
                    <span className="reviewer">{t.name}</span>
                </div>
            ))}
        </section>
    );
}